<template>
  <v-dialog v-model="mapUserDialog" persistent width="500px">
    <v-card>
      <!-- Toolbar -->
      <v-toolbar dense class="gradient-bg elevation-0 white--text">
        <v-toolbar-title>Map User</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="close_dialog" class="white--text mr-n3">mdi-close</v-icon>
      </v-toolbar>

      <!-- Body -->
      <v-card-text class="mt-4">
        <v-form ref="form">
          <v-autocomplete v-model="userList" :items="userData" label="User Name" item-text="user_name"
            item-value="user_id" outlined dense clearable hide-details :rules="[(v) => !!v || 'required']"
            placeholder="Search user..."></v-autocomplete>
          <v-select v-model="boxList" :items="boxData" label="Box Name" item-text="box_name" item-value="box_id"
            :rules="[(v) => !!v || 'required']" outlined dense class="mt-4"></v-select>
        </v-form>
      </v-card-text>
      <div class="d-flex justify-end mb-3 mr-4 mt-n4i">
        <v-card-actions class="">
          <v-btn color="primary" class="white--text" :loading="loading" @click="map_User()" small>Map</v-btn>
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { API, graphqlOperation } from "aws-amplify";
import { claimCardDropdown } from "@/graphql/queries.js";
import { MapCardUsers } from "@/graphql/mutations.js";

export default {
  props: {
    mapUserDialog: {
      type: Boolean,
      default: false,
    },
    mapUserData: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      userList: "",
      boxList: "",
      userData: [],
      boxData: [],
      SnackBarComponent: {},
      loading: false,
    };
  },

  watch: {
    mapUserDialog(newVal) {
      if (newVal === true) {
        this.get_dropdown_list();
      }
    },
  },
  created() {
    this.get_dropdown_list();
  },

  methods: {
    close_dialog() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
      this.$emit("clicked", 0);
    },

    async get_dropdown_list() {
      try {
        const result = await API.graphql(
          graphqlOperation(claimCardDropdown, {
            input: {
              organisation_id: this.$store.getters.get_org_details[0].organisation_id,
            },
          })
        );

        const response = JSON.parse(result.data.claimCardDropdown);
        console.log("response", response);

        if (response.Status === "Success" && response.data) {
          this.userData = response.data.user_details || [];

          this.boxData = response.data.box_details;
          // (response.data.box_details || [])
          //   .filter((b) => b.box_name && b.box_name.trim() !== "") // ✅ Only keep boxes with valid names
          //   .map((b) => ({
          //     box_name: b.box_name,
          //     box_id: b.box_id || b.id,
          //   }));

          // console.log("User Data:", this.userData);
          // console.log("Box Data:", this.boxData);
        } else {
          this.userData = [];
          this.boxData = [];
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            Top: true,
            SnackbarText: response.Message || "No Record Found",
            timeout: 4000,
          };
        }
      } catch (err) {
        console.error("Error fetching dropdown:", err);
        this.userData = [];
        this.boxData = [];
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: err.errors?.[0]?.message || "Error fetching dropdown data",
          timeout: 4000,
        };
      }
    },

    async map_User() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          let result = await API.graphql(
            graphqlOperation(MapCardUsers, {
              input: {
                organisation_id:
                  this.$store.getters.get_org_details[0].organisation_id,
                card_id: this.mapUserData.card_id,
                user_id: this.userList,
                box_id: this.boxList,
              },
            })
          );
          // console.log(result);
          var response = JSON.parse(result.data.MapCardUsers);
          this.loading = false;
          if (response.Status == "Success") {
            this.$emit("successMsg", response.Message);
            this.$refs.form.reset();
            this.$refs.form.resetValidation();
            this.loading = false;
          } else {
            this.$emit("errorMsg", response.Message);
            this.loading = false;
          }
        } catch (error) {
          console.log(error);
          this.$emit("errorMsg", error.errors[0].message);
          this.loading = false;
        }
      }
    },
  },
};
</script>

<style scoped>
.text-blue {
  color: #1976d2;
  cursor: pointer;
}
.text-blue:hover {
  text-decoration: underline;
}

</style>
